export enum ArticleArchitectUploadStatus {
  Pending = 'pending',
  Processing = 'processing',
  Completed = 'completed',
  Failed = 'failed',
}

export enum KnowledgeArticleSourceType {
  Upload = 'upload',
  TrainAI = 'train-ai',
  BCCEmail = 'bcc-email',
  Topdesk = 'topdesk',
}

export enum KnowledgeArticleStatus {
  Draft = 'draft',
  AwaitingReview = 'awaiting-review',
  Published = 'published',
}

export enum ConflictResolutionAction {
  DiscardConflicting = 'discard_conflicting',
  KeepBoth = 'keep_both',
  Merge = 'merge',
}

export enum ConflictType {
  Duplicate = 'duplicate',
  Contradiction = 'contradiction',
  Overlap = 'overlap',
}

export enum ConflictSeverity {
  High = 'high',
  Medium = 'medium',
  Low = 'low',
}

export enum ConflictDetectionChannel {
  Vector = 'vector',
  Lexical = 'lexical',
}

// * Ticketing system a one-time incident pull retrieves from. Kept generic so a
// * second source (Zendesk) reuses the same run-state model and endpoint.
export enum TicketingSource {
  Topdesk = 'topdesk',
  Zendesk = 'zendesk',
}

// * Lifecycle of a ticketing incident pull run, persisted as the source of truth
// * for the frontend to poll. `running` can flip to `failed` on read when the
// * heartbeat goes stale (no background reaper).
export enum TicketIngestionStatus {
  Idle = 'idle',
  Running = 'running',
  Completed = 'completed',
  Failed = 'failed',
}

// * Poll result for the backfill-run-status endpoint. `idle` is the benign no-run
// * state a company that never started a backfill reports; the other values mirror
// * the persisted run lifecycle (BackfillRunStatus in the backend run model), so a
// * dropped socket still surfaces a terminal outcome through the poll.
export enum BackfillRunPollStatus {
  Idle = 'idle',
  Running = 'running',
  Completed = 'completed',
  Failed = 'failed',
  Aborted = 'aborted',
}
